import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=6650cd16"
import script from "./customer.ts?vue&type=script&lang=js&external"
export * from "./customer.ts?vue&type=script&lang=js&external"
import style0 from "./customer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports